/**
 * 描述：租户管理--信息源订阅设置--热点预警
 * 日期：2018-5-3
 * 作者：gao_kaizhi
 */
'use strict';
angular.module('hotWarningTplModule', []).controller('hotWarningTplCtrl', [
    '$scope',
    'trsspliceString',
    '$q',
    '$filter',
    'tManageMentService',
    'modalDialog',
    'trsHttpService',
    '$state',
    function($scope, trsspliceString, $q, $filter, tManageMentService, modalDialog, trsHttpService, $state) {
        initStatus();
        initData();

        /** [initStatus description: 初始化状态] */
        function initStatus() {
            $scope.status = {
                linkXinHua: false,
                linkChengPin: false,
            };
            $scope.data = {
                disaster: [],
                fieldHotList: [],
                areaHotList: [],
                RregionData: '',
                areaInterOrConutry: [],
                selectedLeader: [], // 勾选中的官员ID数组
                searchword: '',
                tenantInfo: {}, // 租户信息
            };
            $scope.isShowImg = false;
        }

        /** [initData description： 初始化数据] */
        function initData() {
            requestRregionData();
            requestInfo().then(function(id) {
                $scope.id = id;
                requestField(id);
                requestDisaster();
                // requestAreaSpits();
            });
        }

        /** [requestInfo description:获取企业的具体信息] */
        function requestInfo() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_tenant',
                methodName: 'findTenantById',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.tenantInfo = data;
                $scope.status.linkXinHua = data.PICKUPXINHUAAGENCY === '1';
                $scope.status.linkChengPin = data.PICKUPENDPRODUCT === '1';
                $scope.startTime = data.STARTTIME;
                $scope.endTime = data.ENDTIME;
                $scope.qiyong = data.STATUS;
                $scope.tenantName = data.TENANTNAME;
                deffer.resolve(data.TENANTID);
            });
            return deffer.promise;
        }

        /** [requestDisaster description: 租户查询自己订阅的灾害信息] */
        function requestDisaster() {
            if ($scope.data.tenantInfo.DISASTERWARNING === undefined) {
                return;
            }
            var arr = $scope.data.tenantInfo.DISASTERWARNING.split(',');
            var params = {
                serviceid: 'mlf_tenant',
                methodName: 'initTenantDisaster',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                for (var i = 0; i < data.length; i++) {
                    if (arr.indexOf(data[i].id) > -1) {
                        $scope.data.disaster.push(data[i]);
                    }
                }
            });
        }

        /**
         * [requestField description]查询租户的领域热点
         * @param  {[type]} id [description]租户ID
         * @return {[type]}    [description]
         */
        function requestField(id) {
            if ($scope.data.tenantInfo.TENANTAREAS === undefined) {
                return;
            }
            var arr = $scope.data.tenantInfo.TENANTAREAS.split(',');
            var params = {
                serviceid: 'mlf_tenant',
                methodName: 'initTenantAreaByAdmin',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                for (var i = 0; i < data.length; i++) {
                    if (arr.indexOf(data[i].ID) > -1) {
                        $scope.data.fieldHotList.push(data[i]);
                    }
                }
            });
        }

        /** [requestAreaSpits description:] */
        function requestAreaSpits() {
            var params = {
                serviceid: 'mlf_tenant',
                methodName: 'DecodeHotSpot',
                TENANTID: $scope.id,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                data = eval(data);
                data = eval(data);
                for (var i = 0; i < data.length; i++) {
                    var arr = [];
                    if (data[i][0].dictNum === '999' || data[i][0].dictNum === '001') {
                        $scope.data.areaInterOrConutry.push(data[i][0].dictNum);
                    } else {
                        for (var j = 0; j < data[i].length; j++) {
                            arr.unshift({ dictName: data[i][j].dictName, dictNum: data[i][j].dictNum });
                        }
                        $scope.data.areaHotList.push(arr);
                    }
                }
                handleAreaHotList();
            });
        }

        /** [link description: 改变稿库接入的状态] */
        $scope.link = function(item) {
            checkIPForlink().then(function(flag) {
                if (flag) {
                    if (item === 1) {
                        $scope.status.linkXinHua = !$scope.status.linkXinHua;
                    } else {
                        $scope.status.linkChengPin = !$scope.status.linkChengPin;
                    }
                    UpdateLinkStatus();
                } else {
                    if (item === 1) {
                        if (!$scope.status.linkXinHua) {
                            modalDialog.alertType('', '稿库接入,需先进入“稿件接入设置”是否进行设置？', 'ask', true, function() {
                                $scope.status.linkXinHua = !$scope.status.linkXinHua;
                                UpdateLinkStatus().then(function() {
                                    $state.go('manageconfig.tenantmanagement.manuAccessSetting');
                                });
                            });
                        } else {
                            $scope.status.linkXinHua = !$scope.status.linkXinHua;
                            UpdateLinkStatus();
                        }
                    } else {
                        if (!$scope.status.linkChengPin) {
                            modalDialog.alertType('', '稿库接入,需先进入“稿件接入设置”是否进行设置？', 'ask', true, function() {
                                $scope.status.linkChengPin = !$scope.status.linkChengPin;
                                UpdateLinkStatus().then(function() {
                                    $state.go('manageconfig.tenantmanagement.manuAccessSetting');
                                });
                            });
                        } else {
                            $scope.status.linkChengPin = !$scope.status.linkChengPin;
                            UpdateLinkStatus();
                        }
                    }
                }
            });
        };

        function UpdateLinkStatus() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_tenant',
                methodname: 'updateTenantInfo',
                ObjectId: $scope.id,
                STARTTIME: $scope.startTime,
                ENDTIME: $scope.endTime,
                STATUS: $scope.qiyong,
                PICKUPXINHUAAGENCY: $scope.status.linkXinHua == true ? '1' : '0',
                PICKUPENDPRODUCT: $scope.status.linkChengPin == true ? '1' : '0',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function() {
                requestInfo();
                defer.resolve();
            });
            return defer.promise;
        }

        /** [checkIPForlink description]检验是否已经完成了稿库接入设置 */
        function checkIPForlink() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_tenantuploadmanage',
                methodName: 'queryTenantUploadManage',
                TENANTNAME: $scope.tenantName,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(res) {
                if (res.DATA.length == 0) {
                    // 因为后端的不正常规格数据返回做了如此判断
                    deffer.resolve(false);
                } else {
                    deffer.resolve(true);
                }
            });
            return deffer.promise;
        }

        /** [handleAreaHotList description: 处理地域热点的数据 以16条为界限初始时最多显示16条] */
        function handleAreaHotList() {
            var num = $scope.data.areaHotList.length > 16 ? 16 : $scope.data.areaHotList.length;
            $scope.showAreaHotList = [];
            for (var i = 0; i < num; i++) {
                $scope.showAreaHotList.push($scope.data.areaHotList[i]);
            }
        }

        /** [requestRregionData description: 获取企业的数据地域信息] */
        function requestRregionData() {
            var params = {
                serviceid: 'mlf_tenant',
                methodName: 'Decode',
                TENANTID: $scope.id,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                data = eval(data);
                data = eval(data);
                if (data != '') {
                    for (var i = data[0].length - 1; i > -1; i--) {
                        $scope.data.RregionData += data[0][i].dictName;
                        if (i != 0) {
                            $scope.data.RregionData += '-';
                        }
                    }
                } else {
                    $scope.data.RregionData = '';
                }
            });
        }

        /** [showMoreArea description: 点击展开获得更多的地域数据] */
        $scope.showMoreArea = function() {
            for (var i = 16; i < $scope.data.areaHotList.length; i++) {
                $scope.showAreaHotList.push($scope.data.areaHotList[i]);
            }
        };

        /** [stopAreaList description: 收起。。只展示16条数据] */
        $scope.stopAreaList = function() {
            $scope.showAreaHotList.splice(16, $scope.data.areaHotList.length - 16);
        };

        /** [ManuLibraryAcc description: 稿库接入设置] */
        $scope.ManuLibraryAcc = function() {
            $state.go('manageconfig.tenantmanagement.manuAccessSetting');
            $scope.$emit('f5', true);
        };
    },
]);
